/* eslint-disable react/prop-types */
import React from 'react';
import { Field } from 'formik';

export const FormikFieldDecorator = (WrappedComponent) => {
  return React.forwardRef((props, ref) => {
    const { name, showWhen, onChange, disabled, disabledWhen, ...rest } = props;

    return (
      <Field name={name}>
        {({ field, form, meta }) => {
          let fieldDisabled = disabled;

          if (showWhen && !showWhen({ field, form, meta })) {
            return null;
          }
          if (disabledWhen) {
            fieldDisabled = disabledWhen({ field, form, meta });
          }
          return (
            <WrappedComponent
              ref={ref}
              onChange={(event, ...args) => {
                if (onChange) {
                  onChange({ field, form, meta }, event, ...args);
                  return;
                }
                if (event && event.target) {
                  field.onChange({
                    target: {
                      name: field.name,
                      value: event.target.value,
                    },
                  });
                } else {
                  field.onChange({
                    target: {
                      name: field.name,
                      value: event,
                    },
                  });
                }
              }}
              onBlur={field.onBlur}
              field={field}
              meta={meta}
              form={form}
              value={field.value || null}
              name={name}
              disabled={fieldDisabled}
              {...rest}
            />
          );
        }}
      </Field>
    );
  });
};
